import React from 'react';
import { Button, message } from 'antd';
import { Link } from 'react-router-dom';
import { Localize, localizeByKeyStatic } from 'components/service';
import { usePermissionsContext } from '../context/permissions-context';

export const SmartHomeButton: React.FC = () => {
  const { hasPermission, isDeveloper } = usePermissionsContext();

  // Function to define the available route
  const getAvailableRoute = (): string | null => {
    // Если пользователь Developer - ведем на users
    if (isDeveloper) {
      return '/users';
    }

    // Check the rights to different routes in order of priority
    const routeChecks = [
      { route: '/users', permission: 'permission_view_users' },
      { route: '/user-roles', permission: 'permission_view_user_roles' },
      { route: '/suppliers', permission: 'permission_view_suppliers' },
      { route: '/teams', permission: 'permission_view_teams' },
      { route: '/flooring', permission: 'permission_view_floorings' },
      { route: '/equipment', permission: 'permission_view_equipments' },
      { route: '/stand-types', permission: 'permission_view_stand_types' },
      { route: '/variable-lists', permission: 'permission_view_variable_lists' },
      { route: '/graphic-rules', permission: 'permission_view_graphic_rules' },
      { route: '/exhibition-types', permission: 'permission_view_exhibition_types' },
      { route: '/organizers', permission: 'permission_view_organizers' },
      { route: '/permissions', permission: 'permission_view_permissions' },
    ];

    for (const check of routeChecks) {
      if (hasPermission(check.permission, 'library', `permission_group_${check.route.slice(1).replace('-', '_')}`, 'permission_action_view')) {
        return check.route;
      }
    }

    // If no routes are available, return null
    return null;
  };

  const availableRoute = getAvailableRoute();

  // If no routes are available, show a message
  if (!availableRoute) {
    return (
      <Button
        type="primary"
        onClick={() => message.error(localizeByKeyStatic('PERMISSION.Error_NoAccessToAnyPage'))}
      >
        <Localize>GLOBAL.Button_Text_BackHome</Localize>
      </Button>
    );
  }

  return (
    <Button type="primary">
      <Link to={availableRoute}>
        <Localize>GLOBAL.Button_Text_BackHome</Localize>
      </Link>
    </Button>
  );
};